import React from 'react'

export default function ResidentOptionsForResearch() {
    return <div>Resident Options for Research</div>
}
